const list = {
    or: '或',
    and: '和',
    separator: '，',
};
export default Object.freeze(list);
